import router from './router'
import PurchasesMessages from './localization'

export default {
  router,
  localization: PurchasesMessages,
}
